<template>
    <div class="container">
        <div class="lail">
            <!-- 
                        <span> مرة واحدة </span>
                    -->
            <button title="Close window" @click="closeWindow">
                <i title="close window" style="transform: rotate(45deg);" class="fas fa-plus"></i>
            </button>
            <h2 id="windowTitle"> أذكار النوم </h2>

            <div>
                <p>
                    بِاسْمِكَ رَبِّـي وَضَعْـتُ جَنْـبي ، وَبِكَ أَرْفَعُـه، فَإِن أَمْسَـكْتَ نَفْسـي فارْحَـمْها ،
                    وَإِنْ أَرْسَلْتَـها فاحْفَظْـها بِمـا تَحْفَـظُ بِه عِبـادَكَ الصّـالِحـين
                </p>
                <span> مرة واحدة </span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <span> صحيح الترمذي : 3401</span>
                <nav>
                    <button class="copy-class" title="Copy"><i class="fas fa-copy"></i></button>
                    <button class="post-twitter" title="Post on twitter"><i class="fab fa-twitter"></i></button>
                    <button class="share-telegram" title="Share on telegram"><i class="fab fa-telegram-plane"></i></button>
                    <button class="share-wa" title="share on whatsapp"><i class="fab fa-whatsapp"></i></button>
                </nav>
            </div>

            <br><br>
            <div>
                <p>
                    اللّهُـمَّ إِنَّـكَ خَلَـقْتَ نَفْسـي وَأَنْـتَ تَوَفّـاهـا لَكَ ممَـاتـها وَمَحْـياها ، إِنْ
                    أَحْيَيْـتَها فاحْفَظْـها ، وَإِنْ أَمَتَّـها فَاغْفِـرْ لَـها . اللّهُـمَّ إِنَّـي أَسْـأَلُـكَ
                    العـافِـيَة
                </p>
                <span> مرة واحدة </span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <span> محتصر مسلم : 1898 </span>
                <nav>
                    <button class="copy-class" title="Copy"><i class="fas fa-copy"></i></button>
                    <button class="post-twitter" title="Post on twitter"><i class="fab fa-twitter"></i></button>
                    <button class="share-telegram" title="Share on telegram"><i class="fab fa-telegram-plane"></i></button>
                    <button class="share-wa" title="share on whatsapp"><i class="fab fa-whatsapp"></i></button>
                </nav>
            </div>

            <br><br>
            <div>
                <p>
                    اللّهُـمَّ قِنـي عَذابَـكَ يَـوْمَ تَبْـعَثُ عِبـادَك
                </p>
                <span> مرة واحدة </span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <span> الصحيحة : 2754</span>
                <nav>
                    <button class="copy-class" title="Copy"><i class="fas fa-copy"></i></button>
                    <button class="post-twitter" title="Post on twitter"><i class="fab fa-twitter"></i></button>
                    <button class="share-telegram" title="Share on telegram"><i class="fab fa-telegram-plane"></i></button>
                    <button class="share-wa" title="share on whatsapp"><i class="fab fa-whatsapp"></i></button>
                </nav>
            </div>

            <br><br>
            <div>
                <p>
                    بِاسْـمِكَ اللّهُـمَّ أَمـوتُ وَأَحْـيا
                </p>
                <span> مرة واحدة </span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <span> الصحيحة : 2754</span>
                <nav>
                    <button class="copy-class" title="Copy"><i class="fas fa-copy"></i></button>
                    <button class="post-twitter" title="Post on twitter"><i class="fab fa-twitter"></i></button>
                    <button class="share-telegram" title="Share on telegram"><i class="fab fa-telegram-plane"></i></button>
                    <button class="share-wa" title="share on whatsapp"><i class="fab fa-whatsapp"></i></button>
                </nav>
            </div>

            <br><br>
            <div>
                <p>
                    للّهُـمَّ عالِـمَ الغَـيبِ وَالشّـهادةِ فاطِـرَ السّماواتِ وَالأرْضِ رَبَّ كُـلِّ شَـيءٍ وَمَليـكَه،
                    أَشْهـدُ أَنْ لا إِلـهَ إِلاّ أَنْت، أَعـوذُ بِكَ مِن شَـرِّ نَفْسـي، وَمِن شَـرِّ الشَّيْـطانِ
                    وَشِـرْكِه، وَأَنْ أَقْتَـرِفَ عَلـى نَفْسـي سوءاً أَوْ أَجُـرَّهُ إِلـى مُسْـلِم
                </p>
                <span> مرة واحدة </span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <span title="null"> الصحيحة : 2763 </span>
                <nav>
                    <button class="copy-class" title="Copy"><i class="fas fa-copy"></i></button>
                    <button class="post-twitter" title="Post on twitter"><i class="fab fa-twitter"></i></button>
                    <button class="share-telegram" title="Share on telegram"><i class="fab fa-telegram-plane"></i></button>
                    <button class="share-wa" title="share on whatsapp"><i class="fab fa-whatsapp"></i></button>
                </nav>
            </div>

            <br><br>
            <div>
                <p>
                    سُبْحَانَ اللَّهِ
                    &nbsp;,&nbsp;
                    الْحَمْدُ لِلَّهِ
                    &nbsp;,&nbsp;
                    اللَّهُ أَكْبَرُ
                </p>
                <span> مائة مرة </span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <span title="null"></span>
                <nav>
                    <button class="copy-class" title="Copy"><i class="fas fa-copy"></i></button>
                    <button class="post-twitter" title="Post on twitter"><i class="fab fa-twitter"></i></button>
                    <button class="share-telegram" title="Share on telegram"><i class="fab fa-telegram-plane"></i></button>
                    <button class="share-wa" title="share on whatsapp"><i class="fab fa-whatsapp"></i></button>
                </nav>
            </div>

            <br><br>
            <div>
                <p>
                    آمَنَ الرَّسُولُ بِمَا أُنْزِلَ إِلَيْهِ مِنْ رَبِّهِ وَالْمُؤْمِنُونَ ۚ كُلٌّ آمَنَ بِاللَّهِ
                    وَمَلَائِكَتِهِ وَكُتُبِهِ وَرُسُلِهِ لَا نُفَرِّقُ بَيْنَ أَحَدٍ مِنْ رُسُلِهِ ۚ وَقَالُوا
                    سَمِعْنَا وَأَطَعْنَا ۖ غُفْرَانَكَ رَبَّنَا وَإِلَيْكَ الْمَصِيرُ. لَا يُكَلِّفُ اللَّهُ نَفْسًا
                    إِلَّا وُسْعَهَا لَهَا مَا كَسَبَتْ وَعَلَيْهَا مَا اكْتَسَبَتْ رَبَّنَا لَا تُؤَاخِذْنَا إِنْ
                    نَسِينَا أَوْ أَخْطَأْنَا رَبَّنَا وَلَا تَحْمِلْ عَلَيْنَا إِصْرًا كَمَا حَمَلْتَهُ عَلَى الَّذِينَ
                    مِنْ قَبْلِنَا رَبَّنَا وَلَا تُحَمِّلْنَا مَا لَا طَاقَةَ لَنَا بِهِ وَاعْفُ عَنَّا وَاغْفِرْ لَنَا
                    وَارْحَمْنَا أَنْتَ مَوْلَانَا فَانْصُرْنَا عَلَى الْقَوْمِ الْكَافِرِينَ
                </p>
                <span> مرة واحدة </span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <span> من قرأ الآيتين (285 - 286) في آخر سورة البقرة في ليلة كفتاه - صحيح مسلم و بخاري </span>
                <nav>
                    <button class="copy-class" title="Copy"><i class="fas fa-copy"></i></button>
                    <button class="post-twitter" title="Post on twitter"><i class="fab fa-twitter"></i></button>
                    <button class="share-telegram" title="Share on telegram"><i class="fab fa-telegram-plane"></i></button>
                    <button class="share-wa" title="share on whatsapp"><i class="fab fa-whatsapp"></i></button>
                </nav>
            </div>

            <br><br>
            <div>
                <strong> قراءة آية الكرسى </strong>
                <p>
                    اللّهُ لاَ إِلَـهَ إِلاَّ هُوَ الْحَيُّ الْقَيُّومُ لاَ تَأْخُذُهُ سِنَةٌ وَلاَ نَوْمٌ لَّهُ مَا فِي
                    السَّمَاوَاتِ وَمَا فِي الأَرْضِ مَن ذَا الَّذِي يَشْفَعُ عِنْدَهُ إِلاَّ بِإِذْنِهِ يَعْلَمُ مَا
                    بَيْنَ أَيْدِيهِمْ وَمَا خَلْفَهُمْ وَلاَ يُحِيطُونَ بِشَيْءٍ مِّنْ عِلْمِهِ إِلاَّ بِمَا شَاء
                    وَسِعَ كُرْسِيُّهُ السَّمَاوَاتِ وَالأَرْضَ وَلاَ يَؤُودُهُ حِفْظُهُمَا وَهُوَ الْعَلِيُّ الْعَظِيمُ
                </p>
                <span> مرة واحدة </span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <span> من قراءة أجير من الجن حتى يصبح - صحيح </span>
                <nav>
                    <button class="copy-class" title="Copy"><i class="fas fa-copy"></i></button>
                    <button class="post-twitter" title="Post on twitter"><i class="fab fa-twitter"></i></button>
                    <button class="share-telegram" title="Share on telegram"><i class="fab fa-telegram-plane"></i></button>
                    <button class="share-wa" title="share on whatsapp"><i class="fab fa-whatsapp"></i></button>
                </nav>
            </div>

            <br><br>
            <div>
                <strong> أذكار من قلق في فراشه ولم ينم </strong>
                <p>
                    عن بريدة رضي الله عنه، قال‏:‏ شكا خالد بن الوليد رضي الله عنه إلى النبي صلى الله عليه وسلم فقال‏:‏
                    يا رسول الله‏!‏ ما أنام الليل من الأرق، فقال النبي صلى الله عليه وسلم‏:‏ ‏"‏إذا أويت إلى فراشك
                    فقل‏:‏ اللهم رب السموات السبع وما أظلت، ورب الأرضين وما أقلت، ورب الشياطين وما أضلت، كن لي جارا من
                    خلقك كلهم جميعا أن يفرط علي أحد منهم أو أن يبغي علي، عز جارك، وجل ثناؤك ولا إله غيرك، ولا إله إلا
                    أنت
                </p>
                <span> مرة واحدة </span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <span title="null"></span>
                <nav>
                    <button class="copy-class" title="Copy"><i class="fas fa-copy"></i></button>
                    <button class="post-twitter" title="Post on twitter"><i class="fab fa-twitter"></i></button>
                    <button class="share-telegram" title="Share on telegram"><i class="fab fa-telegram-plane"></i></button>
                    <button class="share-wa" title="share on whatsapp"><i class="fab fa-whatsapp"></i></button>
                </nav>
            </div>

            <br><br>
            <div>
                <strong> أذكار الأحلام </strong>
                <p>
                    عن أبي قتادة رضي الله عنه قال‏:‏ قال رسول الله صلى الله عليه وسلم‏:‏ ‏"‏الرؤيا الصالحة‏"‏ وفي رواية
                    ‏"‏الرؤيا الحسنة من الله، والحلم من الشيطان، فمن رأى شيئا يكرهه فلينفث عن شماله ثلاثا وليتعوذ من
                    الشيطان، فإنها لا تضره‏
                </p>
                <span> مرة واحدة </span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <span title="null"></span>
                <nav>
                    <button class="copy-class" title="Copy"><i class="fas fa-copy"></i></button>
                    <button class="post-twitter" title="Post on twitter"><i class="fab fa-twitter"></i></button>
                    <button class="share-telegram" title="Share on telegram"><i class="fab fa-telegram-plane"></i></button>
                    <button class="share-wa" title="share on whatsapp"><i class="fab fa-whatsapp"></i></button>
                </nav>
            </div>

        </div>
    </div>
</template>

<script>
import { copyShare } from "./sharing"
import { teleShare } from "./sharing"
import { twitterShare } from "./sharing"
import { waShare } from "./sharing"
export default {

    mounted() {
        copyShare();
        teleShare();
        twitterShare();
        waShare();
    },
    methods: {
        closeWindow() {
            this.$emit("closeLail", false);
        }
    }
}

</script>
